import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateSentModerationVacancy = {
  sentModerationVacancy: { data: null, loading: false, error: null },
};

export const sentModerationVacancy = createAsyncThunk('user/sentModerationVacancy', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(
      `${process.env.REACT_APP_SERVER_API}/vacancies/${id}/moderation/to-employer`,
      {},
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerSentModerationVacancy = {
  [sentModerationVacancy.pending]: (state) => {
    state.sentModerationVacancy.loading = true;
    state.sentModerationVacancy.error = null;
  },
  [sentModerationVacancy.fulfilled]: (state, action) => {
    state.sentModerationVacancy.loading = false;
    state.sentModerationVacancy.data = action.payload;
    state.sentModerationVacancy.error = null;
  },
  [sentModerationVacancy.rejected]: (state, action) => {
    state.sentModerationVacancy.loading = false;
    state.sentModerationVacancy.error = action.payload;
  },
};
